/**
 * Listener foreground de Firebase Cloud Messaging.
 *
 * Traduce los mensajes recibidos por FCM a la capa visual interna de
 * notificaciones (`NotificationContext`) para mostrarlos dentro de la app.
 */
import { getMessaging, onMessage } from "firebase/messaging";
export const initializeOnMessage = (showNotification) => {
  const messaging = getMessaging();

  console.log("[Firebase] Inicializando listener de mensajes...");

  onMessage(messaging, (payload) => {
    console.log("[Firebase] Mensaje recibido:", payload);

    if (payload?.notification && typeof showNotification === "function") {
      console.log("[Firebase] Disparando notificación...");
      showNotification({
        title: payload.notification.title,
        body: payload.notification.body,
        type: "info",
      });
    } else {
      console.error(
        "[Firebase] Payload inválido o showNotification no es función",
        {
          payload,
          showNotification,
        }
      );
    }
  });
};
